<IziGrid height="100%" class="settings-create-challenge">
  <IziCol xl="4" lg="4" md="4" col="12">
    <IziCard>
      <DataTable
        :value="ListSettings"
        selectionMode="single"
        data-key="id"
        @row-select="onRowSelect"
      >
        <Column field="name" header="CHALLENGE TYPE">
          <template #body="slotProps">
            <div
              class="row-challenge-type"
              :class="{
                selected: slotProps.data.name.toLowerCase() === challengeType
              }"
            >
            <div class="title">
              <IziIcon>{{ slotProps.data.icon }}</IziIcon>
              <span>{{ slotProps.data.name }}</span>
            </div>
              <span class="description">{{ slotProps.data.description }}</span>
            </div>
          </template>
        </Column>
      </DataTable>
    </IziCard>
  </IziCol>
  <IziCol xl="8" lg="8" md="8" col="12" class="templates">
    <p class="template-title">SETTING</p>
    <div v-for="(setting, index) in settingsSelect.settings" :key="index">
      <Panel
        class="list-template"
        :header="setting.name"
        :toggleable="true"
        :collapsed="false"
      >
        <component :is="setting.name" v-model:data="setting.data" />
      </Panel>
    </div>
  </IziCol>
  <IziCol class="col-action-settings">
    <IziButton @click="openCreateChallenger" class="next" card="true" label="Next" buttonType="primary" theme="outlined" />
  </IziCol>
</IziGrid>